import AOS from 'aos';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

window.addEventListener('load', () => {
    const section = document.querySelector('.capabilities-cards-section');
    if (!section) {return;}

    const items = section.querySelectorAll('.ccs-item');
    const stepItems = section.querySelectorAll('.ccs-progress-dots .step-item');
    const dots = section.querySelectorAll('.ccs-progress-dots .dot');

    const totalCards = items.length;
    const end = section.offsetHeight * 1;

    let lastActiveIndex = 0;
    let isManualClick = false; // ✅ FIX FLAG

    // Header height
    const header = section.querySelector('.sec-heading');
    const headerHeight = header ? header.offsetHeight + 30 : 0;

    // -------------------------
    // PIN SECTION
    // -------------------------
    ScrollTrigger.create({
        trigger: section,
        start: `top+=${headerHeight}px top`,
        end: () => `+=${end}`,
        pin: true,
        pinSpacing: true,
        scrub: 1,
        onLeave: () => AOS.refresh(),
        onLeaveBack: () => AOS.refresh(),
    });

    // -------------------------
    // SCROLL ANIMATION
    // -------------------------
    ScrollTrigger.create({
        trigger: section,
        start: `top+=${headerHeight}px top`,
        end: () => `+=${end}`,
        scrub: 1,
        onUpdate: (self) => {

            if (isManualClick) {return;} // ✅ STOP conflict

            const progress = self.progress;
            const activeIndex = Math.min(totalCards - 1, Math.floor(progress * totalCards));

            // Fade animation
            if (activeIndex !== lastActiveIndex) {
                const prev = items[lastActiveIndex];
                prev.classList.add('fade');
                setTimeout(() => prev.classList.remove('fade'), 1000);
                lastActiveIndex = activeIndex;
            }

            setActive(activeIndex);

            // Dot fill (scroll based)
            const totalDots = dots.length;

            dots.forEach((dot, i) => {
                const fillThreshold = (i + 1) / totalDots;
                if (progress >= fillThreshold) {
                    dot.classList.add('filled');
                } else {
                    dot.classList.remove('filled');
                }
            });
        },
    });

    // -------------------------
    // SET ACTIVE
    // -------------------------
    function setActive(activeIndex) {
        items.forEach((el, i) => el.classList.toggle('is-active', i === activeIndex));

        stepItems.forEach((item, i) => {
            item.classList.toggle('active', i === activeIndex);
        });
    }

    // -------------------------
    // DOT UPDATE ON CLICK
    // -------------------------
    function updateDotsByIndex(activeIndex) {
        const totalDots = dots.length;
        const totalSteps = stepItems.length;

        const dotsPerStep = totalDots / totalSteps;

        dots.forEach((dot, i) => {
            if (i < (activeIndex + 1) * dotsPerStep) {
                dot.classList.add('filled');
            } else {
                dot.classList.remove('filled');
            }
        });
    }

    // -------------------------
    // CLICKABLE STEP NUMBERS (MOBILE)
    // -------------------------
    if (window.innerWidth < 768) {
        stepItems.forEach((item, index) => {
            const number = item.querySelector('.step-number');
            if (!number) {return;}

            number.style.cursor = 'pointer';

            number.addEventListener('click', () => {
                const scrollTrigger = ScrollTrigger.getAll().find(st => st.trigger === section);
                if (!scrollTrigger) {return;}

                const total = stepItems.length;
                const progress = index / total;

                const start = scrollTrigger.start;
                const end = scrollTrigger.end;

                const targetScroll = start + (end - start) * progress;

                isManualClick = true; // ✅ disable scroll control

                gsap.to(window, {
                    scrollTo: targetScroll,
                    duration: 0.6,
                    ease: 'power2.out',
                    onComplete: () => {
                        isManualClick = false; // ✅ enable again
                    },
                });

                // Manual UI update
                setActive(index);
                updateDotsByIndex(index);
            });
        });
    }

    // -------------------------
    // VIDEO LOGIC (UNCHANGED)
    // -------------------------
    const video = section.querySelector('.ccs-video');

    if (video) {
        const startTime = 5;
        const endTime = 10;

        let current = startTime;
        let target = startTime;

        const smoothFactor = 0.05;

        let lastUpdate = 0;
        const fps = 30;
        const interval = 1000 / fps;

        const initVideo = () => {
            const duration = video.duration;
            if (!duration || isNaN(duration)) {return;}

            video.currentTime = startTime + 0.01;
            video.pause();

            ScrollTrigger.create({
                trigger: section,
                start: `top+=${headerHeight}px top`,
                end: () => `+=${end}`,
                scrub: true,
                onUpdate: (self) => {
                    const progress = self.progress;

                    const totalSegments = totalCards;
                    const segmentSize = 1 / totalSegments;

                    const segmentIndex = Math.min(
                        totalSegments - 1,
                        Math.floor(progress / segmentSize),
                    );

                    const segmentProgress =
                        (progress - segmentIndex * segmentSize) / segmentSize;

                    const eased = gsap.parseEase('sine.inOut')(segmentProgress);

                    const segmentStart =
                        startTime + (endTime - startTime) * (segmentIndex / totalSegments);

                    const segmentEnd =
                        startTime + (endTime - startTime) * ((segmentIndex + 1) / totalSegments);

                    target = segmentStart + (segmentEnd - segmentStart) * eased;
                },
            });

            const updateVideo = (time) => {
                if (time - lastUpdate > interval) {
                    current += (target - current) * smoothFactor;

                    if (Math.abs(current - video.currentTime) > 0.004) {
                        video.currentTime = current;
                    }

                    lastUpdate = time;
                }

                requestAnimationFrame(updateVideo);
            };

            requestAnimationFrame(updateVideo);
        };

        if (video.readyState >= 1) {
            initVideo();
        } else {
            video.addEventListener('loadedmetadata', initVideo);
        }

        video.load();
    }

    setTimeout(() => AOS.refresh(), 100);
});